import { IGlobalSearchResponse } from "src/api/client/search-autocomplete.api";

export const getCombinedResults = (results: IGlobalSearchResponse | null) => [...(results?.wikifolios ?? []), ...(results?.underlyings ?? [])];
